import React, { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Box, Flex, HStack, Text, useColorModeValue, Icon } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { IoMdArrowDropdown, IoMdArrowDropright } from "react-icons/io";

export function IconLinks({ routes }) {
  const location = useLocation();
  const { currUser } = useSelector((state) => state?.auth);
  const auth = currUser?.auth;
  const activeColor = useColorModeValue("gray.700", "white");
  const inactiveColor = useColorModeValue("secondaryGray.600", "secondaryGray.600");
  const brandColor = useColorModeValue("brand.500", "brand.400");
  const hoverBg = useColorModeValue("blue.800", "blue.800");
  const [expandedMenus, setExpandedMenus] = useState({});

  const moduleAccess = (module) => auth?.some(a => a.module === module);

  const roleAccess = (route) => {
    const roleObj = auth?.find(item => item?.module === route?.module);
    return roleObj ? route?.access.includes(roleObj?.access) : false;
  };

  const activeRoute = (routeName) => location.pathname.includes(routeName.toLowerCase());

  const toggleMenu = (path) => {
    setExpandedMenus(prev => ({
      [path]: !prev[path]
    }));
  };

  const renderLink = (route, index) => (
    <NavLink key={index} to={route.path} className="sidebar-link">
      <HStack 
        className={`${activeRoute(route.path) ? 'active-route' : ""}`} 
        py="5px" 
        ps="8px"
        _hover={{ bg: hoverBg }}
      >
        <Flex w="100%" alignItems="center">
          {route.icon && (
            <Box me="5px" className="nav-icon">
              {route.icon}
            </Box>
          )}
          
        </Flex>
        <Box h="30px" w="0px" bg={activeRoute(route.path) ? brandColor : "transparent"} borderRadius="5px" />
      </HStack>
    </NavLink>
  );

  const renderSubRoutes = (route) => {
    if (!route.subRoutes || route.subRoutes.length === 0) return null;
    
    return (
      <Box 
        pl="0px" 
        overflow="hidden"
        transition="all 0.2s ease"
        maxHeight={expandedMenus[route.path] ? "500px" : "0"}
        opacity={expandedMenus[route.path] ? 1 : 0}
      >
        {route.subRoutes.map((subRoute, index) => {
          if (currUser && moduleAccess(subRoute.module) && roleAccess(subRoute)) {
            return renderLink(subRoute, index);
          }
          return null;
        })}
      </Box>
    );
  };

  const renderMenuWithSubRoutes = (route, index) => {
    const hasAccessibleSubRoutes = route.subRoutes?.some(
      subRoute => currUser && moduleAccess(subRoute.module) && roleAccess(subRoute)
    );

    if (!hasAccessibleSubRoutes) return null;

    const isActive = activeRoute(route.path) || route.subRoutes.some(subRoute => activeRoute(subRoute.path));
    const isExpanded = expandedMenus[route.path] ?? isActive;

    return (
      <Box key={index}>
        <Box
          onClick={() => toggleMenu(route.path)}
          cursor="pointer"
          py="5px"
          ps="8px"
          _hover={{ bg: hoverBg }}
        >
          <HStack>
            <Flex w="100%" alignItems="center">
              {route.icon && (
                <Box me="5px" className="nav-icon">
                  {route.icon}
                </Box>
              )}
              <Text
                me="auto"
                color={isActive ? activeColor : inactiveColor}
                fontWeight={isActive ? "bold" : "normal"}
                className="nav-text mt-2"
              >
                {route.name}
               
              </Text>
              <Box  className="sub-menu-icon-drop">
              <Icon
                  mx={4}
                  as={isExpanded ? IoMdArrowDropdown : IoMdArrowDropright}
                  boxSize={5}
                  transition="transform 0.2s ease"
                  transform={isExpanded ? "rotate(0deg)" : "rotate(0deg)"}
                />
              </Box>

            </Flex>
          </HStack>
        </Box>
        {renderSubRoutes(route)}
      </Box>
    );
  };

  const innerData = (routesList) => {
    return routesList.map((route, index) => {
      if (route?.module === 'Log Out') return null;

      if (route.subRoutes && route.subRoutes.length > 0) {
        return renderMenuWithSubRoutes(route, index);
      } 
      else if (currUser && moduleAccess(route?.module) && roleAccess(route)) {
        return renderLink(route, index);
      }
      
      return null;
    });
  };

  const createLinks = (routes) => {
    const topData = routes.filter(route => route.place !== "bottom");
    const bottomData = routes.filter(route => route.place === "bottom");
    return (
      <Flex direction={"column"} justifyContent={"space-between"} height="100%">
        <Box>{innerData(topData)}</Box>
        {bottomData.length > 0 && <Box>{innerData(bottomData)}</Box>}
      </Flex>
    );
  };

  return createLinks(routes);
}

export default IconLinks;
